import type React from "react";
import { Button } from "@/components/ui/button";
import {
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from "@/components/ui/dialog";
import {
	buttonClassNames,
	formHeaderClassNames,
} from "@/shared/constants/customStyleSets";

type Props = {
	onSuccess: () => void;
	otherProps?: React.HTMLAttributes<HTMLDivElement>;
};

export const SuccessUpdateForm: React.FC<Props> = ({
	onSuccess,
	otherProps,
}) => {
	return (
		<div {...otherProps}>
			<DialogHeader>
				<DialogTitle className={formHeaderClassNames}>Success!</DialogTitle>
			</DialogHeader>

			<DialogDescription className="text-[16px] text-center text-foreground mb-4">
				Your plan was changed.
			</DialogDescription>

			<DialogFooter className="sm:justify-center">
				<Button
					type="button"
					variant="secondary"
					className={buttonClassNames}
					onClick={onSuccess}
				>
					Back to the app
				</Button>
			</DialogFooter>
		</div>
	);
};
